import { inject, observer } from "mobx-react";
import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import { Sidebar } from "primereact/sidebar";
import { Calendar } from "primereact/calendar";

import { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";
import CPA from "./CPA";
import RatesTableComponent from "./RatesTableComponent";

import "./style.scss";
import { confirmDialog } from "primereact/confirmdialog";
import ButtonUI from "@UI/ButtonUI";
import RatesAddCompanies from "./RatesAddCompamies";
import moment from "moment";
import { computed, toJS } from "mobx";
import { Button } from "primereact/button";
import RevenueShare from "./RevenueShare";

const categories = new Set(["698c2e49c4d1ec53a29d182c"]);

const Rates = inject("mainStore")(
    observer(({ mainStore, apiUrl, value, item, fix = false, error = false, disabled }) => {
        const ratesArray = mainStore.getMainStore("detailData.ratesArray");
        const { firstParam, secondParam } = useParams();
        const vendor = mainStore.getMainStore("detailData.vendor");
        const offer = mainStore.getMainStore("detailData");

        const isActive = offer ? offer.active : false;
        const isDraft = offer ? offer.draft : false;
        const isArchived = offer ? offer.archived : false;
        const isPause = offer && !isActive && !isDraft && !isArchived ? true : false;

        const [rates, setRates] = useState([{ ...defaultRates }]);
        const [ratesData, setRatesData] = useState([]);
        const [typeRates, setTypeRates] = useState("cpa");
        const [tab, setTab] = useState(null);
        const [visible, setVisible] = useState(false);
        const [disabledSave, setDisabledSave] = useState(true);
        const [editRates, setEditRates] = useState(false);
        const [idRatesEdit, setIdRatesEdit] = useState(false);
        const [openHistory, setOpenHistory] = useState(false);
        const [rateSelectList, setRateSelectList] = useState({ cpa: [], accept: [], cpl: [], cpc: [], cpm: [], revenue_share: [] });
        const [disableRates, setDisableRates] = useState({ cpa: false, accept: false, cpl: false, cpc: false, cpm: false, revenue_share: false });
        const offerDataRates = ratesArray ? ratesArray : [];
        const today = moment().startOf("day");

        const rateIds = firstParam === "companies" ? mainStore.getMainStore(`detailData.vendor.rateIds`) : mainStore.getMainStore(`detailData.rateIds`);

        const ratesDataFilter = ratesDataFilterFunc(ratesData, value) || {};
        const multiSelect = item.multiSelect || false;
        const isAdd = secondParam === "add" ? true : false;

        const isCategories = vendor?.categoriesIds.some((item) => categories.has(item));

        useEffect(() => {
            getRates(apiUrl);
        }, []);

        useEffect(() => {
            const val = validKeys(rates, validRates) || false;
            setDisabledSave(val);
        }, [rates]);

        useEffect(() => {
            if (offer && offer.offerTypeCPC === "cpc") {
                setTypeRates("cpc");
                setRates([{ ...defaultRates, type: typeRates }]);
                setDisableRates({ cpa: true, cpl: true, cpc: false, accept: true, cpm: true, revenue_share: true });
            }

            if (offer && offer.inputFields?.length == 1) {
                if (offer.inputFields.some((item) => item.key === "email")) {
                    setTypeRates("cpa");
                    setRates([{ ...defaultRates, type: typeRates }]);
                    setDisableRates({ cpa: false, cpl: false, cpc: true, accept: false, cpm: false, revenue_share: false });
                }

                if (offer.inputFields.some((item) => item.key === "phone")) {
                    setTypeRates("cpl");
                    setRates([{ ...defaultRates, type: typeRates }]);
                    setDisableRates({ cpa: true, cpl: false, cpc: true, accept: true, cpm: true, revenue_share: true });
                }
            }

            if (offer && offer.inputFields?.length == 2 && offer.inputFields.some((item) => item.key === "email") && offer.inputFields.some((item) => item.key === "phone")) {
                setTypeRates("cpa");
                setRates([{ ...defaultRates, type: typeRates }]);
                setDisableRates({ ...disableRates, cpc: true });
            }
        }, []);

        const rateSelect = useMemo(() => {
            if (ratesData.length === 0 || !offerDataRates) return [];
            return offerDataRates
                .map((m) => {
                    return {
                        item: ratesData.find((f) => f._id === m.rateId),
                        dateStart: moment(m.dateStart).format("YYYY.MM.DD"),
                        dateEnd: m.dateEnd ? moment(m.dateEnd).format("YYYY.MM.DD") : null,
                        history: m.dateEnd && moment(m.dateEnd).isBefore(today, "day") ? true : false,
                    };
                })

                .filter(Boolean);
        }, [ratesData, offerDataRates]);

        useEffect(() => {
            if (ratesData.length > 0) {
                const rateOfferIds = rateIds || [];
                const arr = rateOfferIds.map((id) => ratesData.find((f) => f._id === id)).filter(Boolean);
                const newRates = ratesDataFilterFunc(arr, value);
                setRateSelectList(newRates);
            }
        }, [ratesData, value]);

        useEffect(() => {
            if (visible) {
                setRates([{ ...defaultRates, type: typeRates }]);
            }
        }, [visible]);

        const getRates = async (apiUrl) => {
            const resp = await mainStore.getByUrl(apiUrl, false, "", false, false);
            if (resp && resp.success) {
                setRatesData(resp.data);
            }
        };

        const handleAddRates = () => {
            if (offer && offer.offerTypeCPC) {
                setRates((prev) => prev.concat({ ...defaultRates, type: "cpc" }));
            } else {
                setRates((prev) => prev.concat({ ...defaultRates }));
            }
        };

        const handleDelete = (idx) => {
            const arr = rates.filter((el, index) => index !== idx);
            setRates(arr);
        };

        const handleChange = (e, key) => {
            setTypeRates(e.value);
            setRates(rates.map((rate, index) => (index === key ? { ...rate, type: e.value } : rate)));
        };

        const handleUpdata = (index, updatedRate) => {
            const newRates = [...rates];
            newRates[index] = updatedRate;
            setRates(newRates);
        };

        const handleSave = async () => {
            const resp = await mainStore.postByUrl(`/promo/rates`, { ratesArray: rates });
            if (resp && resp.success) {
                const rateId = resp.data.map((i) => i.data._id);
                if (firstParam === "companies") {
                    mainStore.setMainStore(`detailData.vendor.rateIds`, (Array.isArray(rateIds) ? rateIds : []).concat(rateId));
                    mainStore.putByUrl(`/promo/vendors/${vendor._id}`, { ...vendor, rateIds: (Array.isArray(rateIds) ? rateIds : []).concat(rateId) });
                } else {
                    mainStore.setMainStore(`detailData.rateIds`, (Array.isArray(rateIds) ? value : []).concat(rateId));
                }

                setVisible(false);
                setRates([{ ...defaultRates }]);
                getRates(apiUrl);
            }
        };

        const onTabChange = (e) => {
            setTab({ idx: e.index, key: e.value.key });
        };

        const handleRemoveItem = async (id) => {
            let resp = await mainStore.putByUrl(`/promo/rates/${id}`, { archived: true });
            if (resp && resp.success) {
                getRates(apiUrl);
            }
        };

        const confirmRemove = (id) => {
            confirmDialog({
                header: "Вы уверены, что хотите удалить?",
                message: `Вы выбрали для удаления ставку`,
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "Удалить",
                rejectLabel: "Отмена",
                accept: () => {
                    handleRemoveItem(id);
                },
            });
        };

        const tabItemsDisable = tabItems.map((el, idx) => {
            if (rateSelectList["cpa"]?.filter((i) => i.cpoType === el.key).length) {
                return { ...el, idx };
            } else {
                return { ...el, idx, disabled: true };
            }
        });

        const tabActiveDefault = tabItemsDisable.find((f) => !f.disabled) || { key: "rubPerOrder", idx: 0 };

        const handleEditRates = async (item) => {
            let resp = await mainStore.putByUrl(`/promo/rates/${item._id}`, { ...item });
            if (resp && resp.success) {
                getRates(apiUrl);
            }
        };

        const handleAddRatesCompanies = (el) => {
            const data = { rateId: el.item._id, dateEnd: el.dateEnd ? moment(el.dateEnd).format("YYYY.MM.DD") : null, dateStart: moment(el.dateStart).format("YYYY.MM.DD") };
            mainStore.setMainStore(`detailData.ratesArray`, offerDataRates.concat(data));
        };

        const onChangeCalendar = (value, key) => {
            setEditRates({ ...editRates, [key]: value ? moment(value).format("YYYY.MM.DD") : null });
        };

        const handleDeleteRates = (el) => {
            mainStore.setMainStore(
                `detailData.ratesArray`,
                rateSelect
                    .map((m) => {
                        return { rateId: m.item?._id, dateEnd: m.dateEnd, dateStart: m.dateStart };
                    })
                    .filter((f) => f?.dateEnd !== el?.dateEnd),
            );

            setEditRates(false);
            setIdRatesEdit(false);
        };

        const handleSaveRates = (idx) => {
            const data = { rateId: editRates?.item?._id, dateEnd: editRates.dateEnd ? moment(editRates.dateEnd).format("YYYY.MM.DD") : null, dateStart: moment(editRates.dateStart).format("YYYY.MM.DD") };

            const newArr = ratesArray.toSpliced(idx, 1, data);
            mainStore.setMainStore(`detailData.ratesArray`, newArr);
            setEditRates(false);
            setIdRatesEdit(false);
        };

        const handleEditRatesCreated = (el, key) => {
            if (disabled) return;
            setEditRates((prev) => (prev ? null : el));
            setIdRatesEdit(key);
        };

        let disableRate = { cpa: false, accept: false, cpl: false, cpc: false, cpm: false, revenue_share: false };

        return (
            <div className={`rates_block ${error ? "error" : ""}`}>
                {firstParam === "companies" ? <Button className="rates__button_add" icon="pi pi-plus-circle" text label="Добавить новую ставку" severity="success" onClick={() => setVisible(true)} disabled={disabled} /> : null}
                <Sidebar visible={visible} position="right" onHide={() => setVisible(false)} className="rates-sidebar">
                    <Card title="Ставки">
                        {rates.map((item, key) => {
                            const Specified = wrap[typeRates] ? wrap[typeRates] : CPA;
                            if (offer && offer.inputFields?.length == 1) {
                                if (offer.inputFields.some((item) => item.key === "email")) {
                                    if (isCategories) {
                                        disableRate = { cpa: false, cpl: false, cpc: true, accept: false, cpm: false, revenue_share: false };
                                    } else {
                                        disableRate = { cpa: false, cpl: true, cpc: true, accept: false, cpm: true, revenue_share: true };
                                    }

                                    disableRate = { cpa: false, cpl: false, cpc: true, accept: false, cpm: false, revenue_share: false };
                                }

                                if (offer.inputFields.some((item) => item.key === "phone")) {
                                    disableRate = { cpa: true, cpl: false, cpc: true, accept: true, cpm: true, revenue_share: true };
                                }
                            } else {
                                if (offer.inputFields?.some((item) => item.key === "email")) {
                                    disableRate = { cpa: true, cpl: true, cpc: false, accept: true, cpm: true, revenue_share: true };
                                } else {
                                    if (offer && offer.offerTypeCPC === "cpc") {
                                        disableRate = { cpa: true, cpl: true, cpc: false, accept: true, cpm: true, revenue_share: true };
                                    } else {
                                        disableRate = { cpa: false, cpl: true, cpc: true, accept: false, cpm: true, revenue_share: true };
                                    }
                                }
                                if (offer?.inputFields?.some((item) => item.key === "phone")) {
                                    disableRate = { cpa: true, cpl: false, cpc: true, accept: true, cpm: true, revenue_share: true };
                                }
                            }

                            if (firstParam === "offers") {
                                disableRate = { cpa: false, cpl: false, cpc: false, accept: false, cpm: false, revenue_share: false };
                            }
                            return (
                                <div className="block" key={key}>
                                    {rates.length > 1 ? <div className="rates__number"> Ставка {key + 1}</div> : null}
                                    <div className="radio__block">
                                        {radioButton.map((i, idx) => (
                                            <div className="radio__item" key={idx}>
                                                <RadioButton value={i.value} onChange={(e) => handleChange(e, key)} checked={typeRates === i.value} disabled={disableRate[i.value]} />
                                                <label style={disableRate[i.value] ? { color: "#a3a5a7", fontWeight: "500" } : { color: "", fontWeight: "500" }}>{i.label}</label>
                                            </div>
                                        ))}
                                        {/* {fix ? null : <span className="radio__text">Ставка за телефонный лид, руб.</span>} */}

                                        {rates.length > 1 ? <ButtonUI icon="pi pi-trash" rounded text severity="danger" className="btn_delete" onClick={() => handleDelete(key)} /> : null}
                                    </div>

                                    <Specified item={item} handleUpdata={handleUpdata} index={key} />
                                </div>
                            );
                        })}
                        <div className="group__button">
                            <ButtonUI label={typeRates === "fix" ? "Добавить новый тип оплаты" : "Добавить ставку"} icon="pi pi-plus" outlined onClick={handleAddRates} />
                            <ButtonUI label={typeRates === "fix" ? "Сохранить тип плейсмента" : "Сохранить ставку"} severity="success" onClick={handleSave} disabled={disabledSave} />
                        </div>
                    </Card>
                </Sidebar>

                {multiSelect ? (
                    <>
                        <div className="rates__select_list">
                            {rateSelect
                                ? rateSelect.map((el, key) => {
                                      if (el.history) return;

                                      const isDateStart = el.dateStart ? today.isSameOrAfter(moment(el.dateStart).startOf("day").toDate(), "day") : false;

                                      return (
                                          <div className="rates__item" key={key}>
                                              <div className="rates__item-date">
                                                  <span>Ставка</span>
                                                  <div className="date" onClick={() => handleEditRatesCreated(el, key)}>
                                                      c {moment(el.dateStart).format("DD.MM.YYYY")} до {el.dateEnd ? moment(el.dateEnd).format("DD.MM.YYYY") : "∞"}
                                                      {el.history ? null : <i className="pi pi-pencil"></i>}
                                                  </div>

                                                  {isDateStart ? <div className="chip">Текущая</div> : null}
                                              </div>
                                              {editRates && idRatesEdit === key ? (
                                                  <>
                                                      <div className="block__date">
                                                          <div className={`date__item`}>
                                                              <label>Дата начала периода*</label>
                                                              <Calendar
                                                                  mask={"99.99.9999"}
                                                                  value={moment(editRates.dateStart, "YYYY.MM.DD").toDate()}
                                                                  onChange={(e) => onChangeCalendar(e.value, "dateStart")}
                                                                  dateFormat="dd.mm.yy"
                                                                  locale="rus"
                                                                  timeOnly={false}
                                                                  disabled={moment(editRates.dateStart, "YYYY.MM.DD").isBefore(moment().startOf("day"), "day")}
                                                                  minDate={
                                                                      rateSelect.filter((f) => !f.history)[idRatesEdit - 1]
                                                                          ? moment(rateSelect.filter((f) => !f.history)[idRatesEdit - 1][idRatesEdit - 1]?.dateEnd)
                                                                                .add(1, "days")
                                                                                .toDate()
                                                                          : moment().toDate()
                                                                  }
                                                                  maxDate={
                                                                      rateSelect[idRatesEdit + 1]
                                                                          ? moment(rateSelect[idRatesEdit + 1]?.dateStart)
                                                                                .subtract(2, "days")
                                                                                .toDate()
                                                                          : moment(editRates.dateEnd).subtract(1, "days").toDate()
                                                                  }
                                                              />
                                                          </div>

                                                          <div className={`date__item`}>
                                                              <label>Дата окончания периода</label>
                                                              <Calendar
                                                                  placeholder="Бессрочно или выберите дату"
                                                                  mask={"99.99.9999"}
                                                                  value={editRates.dateEnd ? (moment(editRates.dateEnd, "YYYY.MM.DD").isValid() ? moment(editRates.dateEnd, "YYYY.MM.DD").toDate() : null) : null}
                                                                  onChange={(e) => onChangeCalendar(e.value, "dateEnd")}
                                                                  dateFormat="dd.mm.yy"
                                                                  locale="rus"
                                                                  timeOnly={false}
                                                                  disabled={rateSelect.filter((r) => !r.history).length > 1}
                                                                  maxDate={
                                                                      rateSelect[idRatesEdit + 1]
                                                                          ? moment(rateSelect[idRatesEdit + 1]?.dateStart)
                                                                                .subtract(1, "days")
                                                                                .toDate()
                                                                          : null
                                                                  }
                                                                  minDate={editRates.dateStart && !moment(editRates.dateStart, "YYYY.MM.DD").isBefore(today, "day") ? moment(editRates.dateStart).add(1, "days").toDate() : moment().toDate()}
                                                              />
                                                          </div>
                                                      </div>
                                                      <div className="button__group">
                                                          <ButtonUI severity="success" label={"Сохранить измения"} style={{ width: "50%" }} onClick={() => handleSaveRates(key)} disabled={!editRates.dateStart} />
                                                          {isDraft || (isActive && !isDateStart) || (isArchived && !isDateStart) || (isPause && !isDateStart) ? (
                                                              <ButtonUI severity="danger" label={"Не использовать эту ставку"} style={{ width: "50%" }} onClick={() => handleDeleteRates(el)} />
                                                          ) : null}
                                                      </div>
                                                  </>
                                              ) : null}
                                              <div className="rates__item-element">
                                                  {el?.item?.type === "revenue_share" ? <span style={{ fontWeight: "600" }}>Revenue Share</span> : <span>{el?.item?.type.toUpperCase()}</span>}
                                                  {el?.item?.type === "revenue_share" ? <span>{el?.item?.percentAmount} %</span> : null}
                                                  {el?.item?.type === "revenue_share" ? <span>СЧ: {el?.item?.averageBill} ₽ </span> : null}

                                                  {el.item?.cpoType !== "revenue_share" ? <div>{el.item?.rate}</div> : null}
                                                  <div className="multi__item-comment">{el.item?.comments}</div>
                                              </div>
                                          </div>
                                      );
                                  })
                                : null}
                        </div>

                        {!rateSelect.length || rateSelect[rateSelect.length - 1]?.dateEnd ? (
                            <RatesAddCompanies
                                isAdd={isAdd}
                                error={error}
                                offerDataRates={offerDataRates}
                                rateSelect={rateSelect}
                                ratesDataFilter={ratesDataFilter}
                                handleAddRatesCompanies={handleAddRatesCompanies}
                                endElementRateSelect={rateSelect[rateSelect.length - 1]}
                                disableRates={disableRate}
                                setTypeRates={setTypeRates}
                                typeRates={typeRates}
                            />
                        ) : null}
                    </>
                ) : (
                    <div className="rates__list">
                        {rateSelectList?.cpa?.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>СРA</label>
                                {/* <div>
                                    <TabMenu model={tabItemsDisable} activeIndex={!tab ? tabActiveDefault.idx : tab.idx} onTabChange={onTabChange} />
                                </div> */}
                                <RatesTableComponent items={rateSelectList.cpa} tab={!tab ? tabActiveDefault.key : tab.key} confirmRemove={confirmRemove} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}
                        {rateSelectList?.accept?.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>Accept</label>
                                {/* <div>
                                    <TabMenu model={tabItemsDisable} activeIndex={!tab ? tabActiveDefault.idx : tab.idx} onTabChange={onTabChange} />
                                </div> */}
                                <RatesTableComponent items={rateSelectList.accept} tab={!tab ? tabActiveDefault.key : tab.key} confirmRemove={confirmRemove} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}
                        {rateSelectList?.cpl.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>СРL</label>

                                <RatesTableComponent items={rateSelectList.cpl} cpl={true} confirmRemove={confirmRemove} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}
                        {rateSelectList?.cpc.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>СРC</label>

                                <RatesTableComponent items={rateSelectList.cpc} cpl={true} confirmRemove={confirmRemove} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}

                        {rateSelectList?.cpm.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>СРM</label>

                                <RatesTableComponent items={rateSelectList.cpm} confirmRemove={confirmRemove} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}
                        {rateSelectList?.revenue_share.length ? (
                            <div className="list__block">
                                <label style={{ fontWeight: "600" }}>Revenue Share</label>

                                <RatesTableComponent items={rateSelectList.revenue_share} confirmRemove={confirmRemove} revenue_share={true} handleEditRates={handleEditRates} />
                            </div>
                        ) : null}
                    </div>
                )}
                {!multiSelect ? <ButtonUI className="button__rate" label={"Добавить ставку"} icon="pi pi-plus-circle" outlined onClick={() => setVisible(!visible)} style={{ width: "100%" }} /> : null}
                {rateSelect.filter((f) => f.history).length ? (
                    <Button
                        text
                        label={openHistory ? "Скрыть историю ставок" : "Показать историю ставок"}
                        icon={openHistory ? "pi pi-angle-up" : "pi pi-angle-down"}
                        severity="secondary"
                        style={{ margin: "0 auto" }}
                        onClick={() => setOpenHistory((prev) => !prev)}
                    />
                ) : null}
                {openHistory && (
                    <div className="rates__select_list">
                        {rateSelect
                            ? rateSelect.map((el, key) => {
                                  if (!el.history) return;
                                  const typeLabel = el?.item?.type === "cpl" ? "CPL" : tabItems.find((i) => i.key === el?.item?.cpoType)?.label;
                                  return (
                                      <div className="rates__item" key={key}>
                                          <div className="rates__item-date">
                                              <span>Ставка</span>
                                              <div className="date" onClick={() => handleEditRatesCreated(el, key)}>
                                                  c {moment(el.dateStart).format("DD.MM.YYYY")} до {el.dateEnd ? moment(el.dateEnd).format("DD.MM.YYYY") : "∞"} {el.history ? null : <i className="pi pi-pencil"></i>}
                                              </div>
                                          </div>

                                          <div className="rates__item-element">
                                              <span>{el?.item?.type.toUpperCase()}</span>
                                              <div className={`item__label ${el?.item?.cpoType === "percentAmount" ? "yellow" : el?.item?.cpoType === "rateGradation" ? "blue" : el?.item?.type === "cpl" ? "cpl" : ""}`}>{typeLabel}</div>

                                              {el?.item?.cpoType === "rateGradation" ? null : <div>{el?.item?.rate}</div>}
                                              <div className="multi__item-comment">{el?.item?.comments}</div>
                                          </div>
                                      </div>
                                  );
                              })
                            : null}
                    </div>
                )}
            </div>
        );
    }),
);

const ratesDataFilterFunc = (ratesData, value) =>
    ratesData
        .filter((el) => value.includes(el._id) && !el.archived)
        .reverse()
        .reduce(
            (acc, row) => {
                acc[row.type]?.push(row);
                return acc;
            },
            { cpa: [], accept: [], cpl: [], cpc: [], cpm: [], revenue_share: [] },
        );

const tabItems = [
    { label: "Руб. за заказ", key: "rubPerOrder" },
    { label: "Градация ставок", key: "rateGradation" },
    { label: "% от суммы заказа", key: "percentAmount" },
];

const radioButton = [
    { label: "CPA", value: "cpa" },
    { label: "Accept", value: "accept" },
    { label: "CPL", value: "cpl" },
    { label: "CPC", value: "cpc" },
    { label: "CPM", value: "cpm" },
    { label: "Revenue Share", value: "revenue_share" },
];

const defaultRates = {
    nds: 0, //Ставка НДС
    type: "cpo", //Тип ставки cpo||cpl
    cpoType: "rubPerOrder", //Тип ставки rubPerOrder||rateGradatrion||percentAmount
    rate: null,
    percentAmount: null,
    comments: "",
    indefinitely: false, //Бессрочно
    vendorId: null,
    averageBill: 0,
};

let validRates = { comments: "", percentAmount: null, rate: null, averageBill: 0 };

const validKeys = (arr, validKeysObj) => {
    const clearKeys = (type) => {
        const obj = Object.assign({}, validKeysObj);
        switch (type) {
            case "revenue_share":
                delete obj.rate;

                break;

            default:
                delete obj.averageBill;
                delete obj.percentAmount;
                break;
        }

        return obj;
    };

    let isNotValid = true;

    for (let i = 0; i < arr.length; i++) {
        const el = arr[i];
        const objValid = clearKeys(el.type);
        if (el.indefinitely) delete objValid.dateEnd;

        const validKey = Object.entries(objValid).some(([key, val]) => {
            if (Array.isArray(el[key])) {
                return validKeys(el[key], val);
            } else {
                return el[key] == val;
            }
        });

        isNotValid = validKey;
        if (validKey) break;
    }

    return isNotValid;
};

const wrap = {
    cpa: CPA,
    accept: CPA,
    cpl: CPA,
    cpc: CPA,
    cpm: CPA,
    revenue_share: RevenueShare,
};

export default Rates;
